import { gql } from '@apollo/client';

export const READ_PARKING_ZONE_CHARGING_STATIONS = gql`
  query readParkingZoneChargingStations(
    $input: ReadParkingZoneChargingStationsInput!
  ) {
    readParkingZoneChargingStations(input: $input) {
      id
      chargingLocationId
      status
      evses {
        id
        status
        connectors {
          status
          type
          power
        }
        publicDisplayId
      }
    }
  }
`;
